// frontend/src/components/league/LeagueErrorState.tsx
//
// Friendly full-page state for league-scoped failures. The common real case
// is a non-member hitting a league URL (backend 403 "You are not a member of
// this league.") - that gets purpose-built copy + a way back instead of raw
// red error text floating on an empty page.
import React from 'react';
import { Link } from 'react-router-dom';

const LeagueErrorState: React.FC<{ message?: string | null }> = ({ message }) => {
  const notMember = (message ?? '').toLowerCase().includes('not a member');
  return (
    <div className="flex flex-col items-center justify-center min-h-[50vh] p-6 text-center">
      <div className="bg-primary-dark border border-gray-800 rounded-xl p-8 max-w-sm w-full">
        <h2 className="font-heading font-bold text-lg text-gray-100 mb-2">
          {notMember ? "You're not in this league" : 'Something went wrong'}
        </h2>
        <p className="text-sm text-gray-400 mb-6">
          {notMember
            ? 'Ask the commissioner for an invite link to join.'
            : (message || 'Failed to load league information.')}
        </p>
        <div className="grid gap-3 sm:grid-cols-2">
          <Link to="/season-long/dashboard" className="btn-primary flex min-h-11 items-center justify-center px-4">
            My Leagues
          </Link>
          <Link to="/home" className="btn-outline flex min-h-11 items-center justify-center px-4">
            Go Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default LeagueErrorState;
